<!-- =========================================================================================
  File Name: Product.vue
  Description: Product product Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Producto no encontrada" :active.sync="id_not_found">
      <span>Datos de producto con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'products'}" class="text-inherit underline"> todos los productos</router-link>
      </span>
    </vs-alert>

    <vx-card v-show="loaded" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <div class="vx-col flex-1">
            <div class="w-full">
              <div class="w-full vx-row">
                <div class="vx-col w-1/3">
                  <ejs-textbox floatLabelType="Auto" placeholder="Código" :enabled="editing" v-model="data_local.code"/>
                </div>
                <div class="vx-col w-1/3">
                  <ejs-dropdownlist floatLabelType="Auto" placeholder="Tipo" highlight=true :dataSource="productTypes" :fields="{text: 'value', value: 'code'}" v-model="data_local.type" :enabled="editing"></ejs-dropdownlist>
                </div>
              </div>
              <div class="w-full">
                <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :enabled="editing" v-model="data_local.name"/>
              </div>
              <div class="w-full">
                <ejs-textbox name="description" :multiline="true" floatLabelType="Auto" placeholder="Descripción completa del producto" v-model="data_local.description" :enabled="editing"/>
              </div>
              <div class="w-full vx-row">
                <div class="vx-col w-1/3">
                  <ejs-numerictextbox floatLabelType="Auto" placeholder="Precio" format="N2" :enabled="editing" textAlign='Right' v-model="data_local.price"/>
                </div>
                <div class="vx-col w-1/3">
                  <ejs-dropdownlist floatLabelType="Auto" placeholder="Categoría" highlight=true :dataSource="categories" :fields="{text: 'name', value: 'id'}" v-model="data_local.categoryId" :enabled="editing"></ejs-dropdownlist>
                </div>
                <div class="vx-col w-1/3">
                  <ejs-dropdownlist floatLabelType="Auto" placeholder="Estado" highlight=true :dataSource="status" :fields="{text: 'value', value: 'code'}" v-model="data_local.statusId" :enabled="editing"></ejs-dropdownlist>
                </div>
              </div>
              <div class="w-full vx-row mt-1 mb-1">
                <div class="vx-col w-1/5">
                  <ejs-checkbox label='Disponible en punto de venta' v-model="data_local.availableInPOS" :checked="data_local.availableInPOS" :disabled="!editing"></ejs-checkbox>
                </div>
                <div class="vx-col w-1/5">
                  <ejs-checkbox label='Es un combo/descuento' v-model="data_local.combo" :checked="data_local.combo" :disabled="!editing"></ejs-checkbox>
                </div>
              </div>
              <!--              <div class="w-full mt-2 mb-2">-->
              <!--                <ejs-checkbox label='Disponible en punto de venta' v-model="data_local.availablePOS" :checked="data_local.availablePOS" :disabled="!editing"></ejs-checkbox>-->
              <!--              </div>-->
              <div class="w-full">
                <ejs-textbox name="comments" :multiline="true" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :enabled="editing"/>
              </div>

              <div class="w-full">
                <vs-upload limit="1" text="Cargar imagen" ref="fileUpload" :disabled="!editing"/>
                <vs-button class="ml-10" color="danger" @click="removeImage">Eliminar imagen</vs-button>
              </div>

            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
var deltaPOS_config = require('@/deltaPOS.config.js')

import Vue from "vue";
import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DropDownListPlugin);

export default {
  data() {
    return {
      loaded: false,
      editing: false,
      id: 0,
      data: null,
      categories: [],
      status: [],
      productTypes: [],
      data_local: {
        id: 0,
        code: '',
        name: '',
        description: '',
        categoryId: 0,
        price: 0.0,
        type: 'B',
        availableInPOS: false,
        combo: false,
        comments: '',
        statusId: 0
      },
      id_not_found: false,
    }
  },
  methods: {
    reset_data() {
      if (this.id > 0) {
        this.removeImage();
        this.data_local = JSON.parse(JSON.stringify(this.data));
        if (this.data.image) {
          this.$refs.fileUpload.srcs.push({src: 'data:image/gif;base64,' + this.data.image});
        }
        this.editing = false;
      } else {
        this.$router.push({name: 'products'});
      }
    },
    removeImage() {
      if (this.$refs.hasOwnProperty('fileUpload')) {
        while (this.$refs.fileUpload.srcs.length > 0) {
          this.$refs.fileUpload.srcs.pop();
        }
      }
    },
    getData(id) {
      if (id) {
        if (id == 0) {
          this.$vs.loading.close();
          this.loaded = true;
          this.id_not_found = false;
          this.editing = true;
        } else {
          var self = this;
          this.$http.post(deltaPOS_config.default.apiURL + '/products/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
            if (response.data.success) {
              self.data = response.data.data;
              self.data_local = JSON.parse(JSON.stringify(response.data.data));
              if (self.data.image) {
                self.$refs.fileUpload.srcs.push({src: 'data:image/gif;base64,' + self.data.image});
              }
            } else {
              if (id > 0) {
                self.id_not_found = true;
              }
            }
            self.$vs.loading.close();
            self.loaded = true;
          })
        }
      } else {
        this.$vs.loading.close();
        this.loaded = true;
        if (id == 0) {
          this.id_not_found = false;
        }
        this.editing = true;
      }
    },
    validateForm() {
      var message = '';
      if (this.data_local.code.trim() == '') {
        message = 'Debe indicar un código';
      } else if (this.data_local.name.trim() == '') {
        message = 'Debe indicar una descripción';
      }
      if (message != '') {
        this.$vs.notify({
          title: 'Error validando información',
          text: message,
          color: 'danger'
        });
      }
      return (message == '');
    },
    save() {
      if (this.validateForm()) {
        this.$vs.loading({
          text: 'Guardando información de producto',
          type: 'point'
        });
        var self = this;
        this.data_local.id = this.id;
        this.data_local.context = this.$store.state.AppActiveUser;
        this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
        for (var i = 0; i < this.$refs.fileUpload.srcs.length; i++) {
          var imageData = '';
          if (this.$refs.fileUpload.srcs[i].src) {
            var imageInfo = this.$refs.fileUpload.srcs[i].src.split(',');
            for (var j = 0; j < imageInfo.length; j++) {
              if (j > 0) {
                imageData += imageInfo[j];
              }
            }
          }
          this.data_local.image = imageData;
        }
        this.$http.post(deltaPOS_config.default.apiURL + '/products/save', this.data_local).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Datos de la producto fueron actualizados correctamente',
              color: 'primary'
            });
            if (self.id == 0) {
              self.$router.push({name: 'product', params: {id: response.data.data.id}});
            }
            this.editing = false;
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.$vs.loading.close();
        });
      }
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirmar`,
        text: `Se dispone a eliminar producto "${this.data.name}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      })
    },
    deleteRecord() {
      this.$vs.loading({
        text: 'Eliminando producto',
        type: 'point'
      });
      var self = this;
      var data = {
        id: this.id,
        context: this.$store.state.AppActiveUser
      };
      this.$http.post(deltaPOS_config.default.apiURL + '/products/delete', data).then(response => {
        if (response.data.success) {
          self.$vs.notify({
            title: 'Información eliminada',
            text: 'Datos de la producto fueron eliminados correctamente',
            color: 'primary'
          });
          self.$router.push({name: 'products'});
        } else {
          self.$vs.notify({
            title: 'Error al actualizar',
            text: response.data.message,
            color: 'danger'
          });
        }
        this.editing = false;
        this.$vs.loading.close();
      });
    }
  },

  mounted() {
    this.id = parseInt(this.$route.params.id);
    if (this.id > 0) {
      this.$vs.loading({
        text: 'Cargando datos de producto',
        type: 'point'
      });
    }
    var self = this;
    this.$http
      .post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'ESTADOPRODUCTO'})
      .then(response => {
        if (response.data.success) {
          self.status = response.data.data;
        }
        return self.$http.post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'TIPOPRODUCTO'})
      })
      .then(response => {
        if (response.data.success) {
          self.productTypes = response.data.data;
        }
        return self.$http.post(deltaPOS_config.default.apiURL + '/products/categories/list', self.$store.state.AppActiveUser);
      })
      .then(response => {
        if (response.data.success) {
          self.categories = response.data.data;
        }
        self.getData(this.id);
      })
      .catch(error => {
        var errorMessage = '';
        if (error.response) {
          errorMessage = error.response.data.ErrorMessage
        } else {
          errorMessage = 'Error de conectividad al cargar catálogo'
        }
        self.$vs.notify({
          title: 'Error al cargar catálogo',
          text: errorMessage,
          color: 'danger'
        });
      });
  }
}
</script>

<style lang="scss">
@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
/*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
/*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
/*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
/*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
/*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
